import React from 'react';
import LoadAd from './LoadAd';
import {isMobile} from 'react-device-detect';
import { Button } from 'antd';

import moment from 'moment';
import config from '../config/config';

import S from 'string';
import _ from 'lodash';

const TAG_HOME = 204;
const TAG_SALE = 205;
const TAG_IMPORTANT = 206;
const TAG_SEMINAR = 207;
const TAG_TRAVELSAMPLE = 250;

const CATEGORY = [
  {key: 199, category: 'mobile'},
  {key: 200, category: 'travel', url:'/data/travel'},
  {key: 201, category: 'school', url:'/data/school'},
];

const SubHeader = ({tags, cls}) => {
//      console.info(tags, tags.length);
  const ret = [];

  if(tags.length == 0){
    return null;
  }

  if(tags.includes(TAG_IMPORTANT)){
    ret.push(<span key="important"><a href="/weblog/info_tag/important" className={cls+"-pickup__tag is-important"}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> 重要なお知らせ</a></span>);
  }
  if(tags.includes(TAG_SALE)){
    ret.push(<span key="sale"><a href="/weblog/info_tag/sale" className={cls+"-pickup__tag is-sale"}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> セール</a></span>);
  }
  if(tags.includes(TAG_TRAVELSAMPLE)){
    ret.push(<span key="travel-sample"><a href="/weblog/info_tag/travel-sample" className={cls+"-pickup__tag is-travel-sample"}><i className="fa fa-suitcase" aria-hidden="true"></i> 旅行サンプル</a></span>);
  }
  if(tags.includes(TAG_SEMINAR)){
    ret.push(<span key="seminar"><a href="/weblog/info_tag/seminar" className={cls+"-pickup__tag"}>セミナー</a></span>);
  }
  return ret;
};

const parseItem = (item) => {
  const title = item.title.rendered;
  const desc  = S(item.content.rendered).stripTags().decodeHTMLEntities().s;

  let acf = (item.acf['item-url'])?item.acf['item-url'].match(/\/([^\/]+)[\/]?$/):false;
  if(acf){
    acf = acf[1];
  }
  //acf = 'green-island-eco-adventure';
//      console.info(acf);

  let categories = [];
  if(item.info_category){
    item.info_category.map(c => {
      const m = _.find(CATEGORY, {'key': c});
      if(m){
        categories.push(m);
      }
    });
  }


  // page data in next page
  const data = {
    id: item.id,
    date: moment(item.date).format(config.format.date),
    title: title,
    summary: desc,
    desc: item.content.rendered,
    tags: item.info_tag,
    category: (categories[0])?categories[0]:null,
    ad: acf
  };

  return data;
}

const NewsItem = ({item, index, showDetail}) => {
  const data  = parseItem(item);
  const isNew = (index < 2)?"is-new":'';
  const ht = isMobile?'51px':'60px';
  const cls = (item.page && item.page=="home")?"home":"module";
  const cat = _.join(item.info_category, ' cat-');

  return(
    <div className={cls+"-pickup "+isNew + " cat-"+cat}>
      <div style={{position: 'absolute', right: '0', top:'-28px'}} className="text-right text-xs-right">
        <SubHeader tags={data.tags} cls={cls}/>
      </div>
      <div className="row align-items-center">
        <div className="col-4 col-xs-4">
        </div>
        <div className="col-8 text-right col-xs-8 text-xs-right">
          <div className={cls+"-pickup__time"}><time>{data.date}</time></div>
        </div>
      </div>
      <h3 className={cls+"-pickup__title"}
          onClick={(e) => showDetail(data, index, e)}
      >{data.title}</h3>
      <p className={cls+"-pickup__desc"} style={{height: ht, overflow:'hidden'}}>{data.summary}</p>
      <div className="text-right text-xs-right">
        <Button
          onClick={(e) => showDetail(data, index, e)}
          className="btn btn-secondary btn-xs gtm_info-from-wp__viewmore"
        >続きを読む</Button>
      </div>
    </div>
  );
}

export default NewsItem;



// WEBPACK FOOTER //
// ./src/pages/news/components/NewsItem.js